import { render, staticRenderFns } from "./monacoEditor.vue?vue&type=template&id=78d4fe51&scoped=true&"
import script from "./monacoEditor.vue?vue&type=script&lang=js&"
export * from "./monacoEditor.vue?vue&type=script&lang=js&"
import style0 from "./monacoEditor.vue?vue&type=style&index=0&id=78d4fe51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d4fe51",
  null
  
)

export default component.exports